import { ethers } from 'ethers';

function filterAddressList(items) {
    return items.filter(
        item => ethers.utils.isAddress(item)
    );
}
export default filterAddressList